import React from 'react';
import './ButtonZap.css';
import { Link } from 'react-router-dom';
import imagemZap from '../imgs/zap.svg'
import { rooseveltZap } from '../imports/Links'

const BackToTop = () => {
    return (
        <div className="button-zap">
            <Link to={rooseveltZap} target='_blank'>
                <img src={imagemZap} alt="icon whatsapp" />
            </Link>
        </div>
    );
};

export default BackToTop;
